import React, { useState } from "react";
import { Button, DropdownToggle, DropdownMenu, DropdownItem, UncontrolledDropdown } from "reactstrap";
import PropTypes from "prop-types";
import style from "./Grid.module.scss";
import { TransactionStatus } from "../types";
import { showToast } from "../../../../utils/Helper";
import ModalConfirm from "../../../Profile/Modal/ModalConfirm";

function Actions({ commission, handleRefresh, fetchs, Link }) {
  const [loading, setLoading] = useState(false);
  const [modalConfirm, setModalConfirm] = useState({
    open: false,
    title: "",
    callback: undefined,
  });

  const showHistory = () => {
    alert("Not working yet");
  };

  const revert = () => {
    alert("Not working yet");
    setModalConfirm({ open: false });
  };

  const book = () => {
    setLoading(true);
    fetchs.bookRecurringCommission({ id: commission.RecurringCommissionId }, (res) => {
      setLoading(true);
      setModalConfirm({ open: false, title: "", callback: undefined });
      if (res && res.result && res.result.Code === 200) {
        handleRefresh();
        showToast("Recurring Commission Booked!");
      } else {
        showToast(res && res.result ? res.result.Description : "Server Error", true);
      }
    });
  };

  const cancel = () => {
    setLoading(true);
    fetchs.updateRecurringCommission(
      {
        k2btrnmode: "DLT",
        recurringcommissionsdt: { ...commission },
      },
      (res) => {
        setLoading(false);
        setModalConfirm({ open: false, title: "", callback: undefined });
        if (res && res.result && res.result.Code === 200) {
          handleRefresh();
          showToast("Recurring Commission canceled.");
        } else {
          showToast(res && res.result ? res.result.Description : "Server Error", true);
        }
      }
    );
  };

  const crossReference = () => {};

  const action = {
    Cancel: cancel,
    Book: book,
    Revert: revert,
    CrossReference: crossReference,
  };

  const handleAction = (a) => {
    setModalConfirm({
      title: `Are you sure you want to ${a} the selected Rec. Commission?`,
      callback: action[a],
      open: true,
    });
  };

  return (
    <React.Fragment>
      <div className={style.actions}>
        {/* <Button
          outline
          color="primary"
          size="sm"
          key={`action-history-${commission.RecurringCommissionId}`}
          onClick={showHistory}
          className={style.iconBtn}
        >
          <i className="fa fa-history" />
        </Button> */}

        <UncontrolledDropdown>
          <DropdownToggle color="link" size="lg" className={style.dropdown}>
            <i className="icon-options-vertical icons d-block" />
          </DropdownToggle>
          <DropdownMenu>
            {commission.RecurringCommissionStatus.trim() === TransactionStatus.Initiated && (
              <React.Fragment>
                <DropdownItem onClick={() => handleAction("Cancel")}>Cancel</DropdownItem>
                <DropdownItem onClick={() => handleAction("Book")}>Book</DropdownItem>
              </React.Fragment>
            )}
            <React.Fragment>
              {/* <DropdownItem onClick={() => handleAction("Revert")}>
                  Revert
                </DropdownItem> */}
              <DropdownItem
                tag={Link}
                to={`/crossReference/RecurringCommissions/${commission.RecurringCommissionId}`}
              >
                Go To Cross Reference
              </DropdownItem>
            </React.Fragment>
          </DropdownMenu>
        </UncontrolledDropdown>
      </div>
      <ModalConfirm
        open={modalConfirm.open}
        callback={modalConfirm.callback}
        title={modalConfirm.title}
        {...modalConfirm}
        saving={loading}
        toggle={() => setModalConfirm({ open: false, title: "", callback: undefined })}
      />
    </React.Fragment>
  );
}

Actions.propTypes = {
  commission: PropTypes.object.isRequired,
  handleRefresh: PropTypes.func.isRequired,
};

export default Actions;
